import Select from 'react-select';

import {BasicDistributorT} from '@/lib/types/user.types';

type DistributorSelectorProps = {
  distributors: BasicDistributorT[];
  selectedDistributor: BasicDistributorT | null;
  setSelectedDistributor: (distributor: BasicDistributorT | null) => void;
};

const DistributorSelector = ({distributors, selectedDistributor, setSelectedDistributor}: DistributorSelectorProps) => {
  return (
    <div className="w-full">
      <label htmlFor="distributor-selector">Distributor</label>
      {distributors.length <= 1 ? (
        <div className="rounded-lg bg-[#1a1a1a] p-2 text-white">
          {distributors[0]?.distributor_name || 'No distributors available'}
        </div>
      ) : (
        <Select
          options={distributors.map(distributor => ({
            label: distributor.distributor_name,
            value: distributor.distributor_id,
          }))}
          value={
            selectedDistributor
              ? {
                  label: selectedDistributor.distributor_name,
                  value: selectedDistributor.distributor_id,
                }
              : null
          }
          onChange={option =>
            setSelectedDistributor(distributors.find(d => d.distributor_id === option?.value) ?? null)
          }
          styles={{
            control: (styles, state) => ({
              ...styles,
              borderColor: state.isFocused ? '#007bff' : styles.borderColor,
              background: '#1a1a1a',
              color: '#fff',
              borderRadius: '0.5rem',
              padding: '0.5rem',
            }),
            menu: styles => ({
              ...styles,
              background: '#1a1a1a',
            }),
            option: (styles, {isFocused, isSelected}) => ({
              ...styles,
              background: isFocused ? '#2a2a2a' : isSelected ? '#1a1a1a' : '#1a1a1a',
              color: '#fff',
              ':active': {
                backgroundColor: '#2a2a2a',
              },
            }),
            singleValue: styles => ({
              ...styles,
              color: '#fff',
            }),
          }}
        />
      )}
    </div>
  );
};

export default DistributorSelector;
